const URL_API= ( function(){
    if( location.hostname === "localhost") {
        return "https://ionel.theappsonline.com/api/"
    }
    else{
        return "https://ionel.theappsonline.com/api/"
    }
})();

const URL_WWW= ( function(){
    if( location.hostname === "localhost") {
        return "https://localhost:8080/"
    }
    else{
        return "https:/ionel.theappsonline.com/"
    }
})();

export const CONFIG_ENV = {


    URL_REGISTERING:{
        "register_by_email" : URL_API+ "register/by_email",
        "get_note" : URL_API+ "infohelp/api/api/note/getnote",
        "delete" : URL_API+ "infohelp/api/api/note/delete",
        "get_all_notes": URL_API+ "infohelp/api/api/note/getall",
        "insert_new_tag" : URL_API+ "infohelp/api/api/tags/new",
        "get_all_tags": URL_API+ "infohelp/api/api/tags/getall",
    },
    URL_USER:{
        "check_token_for_permanent_session" : URL_API+ "user/check_token_for_permanent_session",
        "resendForValidateEmail" : URL_API+ "user/resend_for_validate_email",
        "resetPasswordForEmail" : URL_API+ "user/reset_password_for_email",
        "authenticateWithEmailAndPassword" : URL_API+ "user/authenticate_with_email_and_password",
        "saveMyProfile" : URL_API+ "user/save_my_profile",
        "getEmailForUserId" : URL_API+ "user/get_email_for_userid",
        "getMyImageProfile" : URL_API+ "user/get_my_image_profile",
        "getMyImageProfileAsString" : URL_API+ "user/get_my_image_profile_as_string",
        "uploadImageMyProfile" : URL_API+ "user/upload_image_my_profile",
    },
    URL_LISTS:{
        "getImageAsAvatarForList" : URL_API+ "lists/get_image_as_avatar_for_list",
        "getImageForList" : URL_API+ "lists/get_image_for_list",
        "uploadImageForList" : URL_API+ "lists/upload_image_for_list",
        "distribuieLista" : URL_API+ "lists/distribuie_lista",
    } ,
    URL_GIFTS:{
        "get_lists" : URL_API+ "gifts/all_lists",
        "save_list" : URL_API+ "gifts/save_list",
        "update_gift_in_list" : URL_API+ "gifts/update_gift_in_list",
        "new_list" : URL_API+ "gifts/new_list",
        "get_list_details" : URL_API+ "gifts/get_list_details",
        "get_list_gifts" : URL_API+ "gifts/get_list_gifts",
        "new_gift_to_list" : URL_API+ "gifts/new_gift_to_list",
        "delete_gift_from_list" : URL_API+ "gifts/delete_gift_from_list",
        "new_partaker_to_list" : URL_API+ "gifts/new_partaker_to_list",
        "get_list_partakers" : URL_API+ "gifts/get_list_partakers",
        "delete_partaker_from_list" : URL_API+ "gifts/delete_partaker_from_list",
        "get_gift_details_from_curl" :URL_API+ "gifts/get_gift_details_from_curl",
        "add_giftid_from_suggestions_to_list": URL_API+ "gifts/add_giftid_from_suggestions_to_list",
    } ,
    URL_NOMENCLATURES:{
        "get_nom_categ_of_events" : URL_API+ "nomenclatures/nom_categ_of_events",
        "get_nom_types_of_events" : URL_API+ "nomenclatures/nom_types_of_events",
    },
    URL_PUBLIC_INFO:{
        "get_last_public_lists" : URL_API+ "publicinfo/get_last_public_lists",
        "get_last50_public_lists" : URL_API+ "publicinfo/get_last50_public_lists",
        "get_last50_public_gift_ideas" : URL_API+ "publicinfo/get_last50_public_gift_ideas",
        "get_list_details" : URL_API+ "publicinfo/get_list_details",
        "get_list_gifts" : URL_API+ "publicinfo/get_list_gifts",
        "get_gift" : URL_API+ "publicinfo/get_gift",
        "get_list_partakers" : URL_API+ "publicinfo/get_list_partakers",
        "getImageAsAvatarForGift" : URL_API+ "publicinfo/get_image_as_avatar_for_gift",
    }
}
